import { ActionButtonProps, Box, BoxProps, ButtonNew } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useEffect } from 'react'
import { Screens } from '../../../nav/Screens'
import { Colors } from '../../../util/utill'
import { nativeJSComm, nativeJSMapper } from '../../../util/WebFns'
import { DomesticMoneyTransferStrings } from '../Strings'

export const ActionButtons = ({ isValid }: ActionButtonProps) => {
  const navigation = useNavigation()

  useEffect(() => {
    nativeJSComm(nativeJSMapper.enableScreenShot)
    return () => nativeJSComm(nativeJSMapper.disableScreenshot)
  }, [])

  const onConfirmPress = () => {
    navigation.reset({
      index: 0,
      routes: [
        {
          name: Screens.DOMESTIC_MONEY_TRANSFER_LOGIN as never,
          params: {
            type: 'RESET_LOGIN_STACK', // this second parameter is for sending the params
          },
        },
      ],
    })
  }

  return (
    <Box {...styles.buttonContainer}>
      <ButtonNew
        title={DomesticMoneyTransferStrings.initiateNewTrans}
        onPress={onConfirmPress}
        disabled={!isValid}
        height={45}
        color={Colors.LIGHT_SKY_BLUE}
        textType={'bodyMedium12'}
        {...styles.submitButton}
        type={'primaryFullWidth'}
      />
    </Box>
  )
}

const styles = {
  submitButton: {
    borderRadius: 22,
  },
  buttonContainer: {
    justify: 'center',
    pt: 30,
    ph: 8,
    alignContent: 'center',
  } as BoxProps,
}
